/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { CouponWithCode } from './CouponWithCode';
import { CouponWithoutCode } from './CouponWithoutCode';
const CourseCouponParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['coupon-with-code', CouponWithCode],
    ['coupon-without-code', CouponWithoutCode],
]);
export const CourseCoupon = CourseCouponParser;
